import Vue from 'vue'
import VueI18n from 'vue-i18n'
import messages from 'src/i18n'
import { locale } from './../modules/language'
import { setQuasarInternalLanguage } from './../modules/quasarInternalLanguage'

Vue.use(VueI18n)

const localeSelected = localStorage.getItem('locale')
const currentLocale = localeSelected || locale

const i18n = new VueI18n({
  locale: currentLocale,
  messages
})

const cookieLocale = currentLocale.toLowerCase().slice(0, 2)
document.cookie = `django_language=${cookieLocale}`

setQuasarInternalLanguage(currentLocale)

export default ({ app }) => {
  // Set i18n instance on app
  app.i18n = i18n
}

export { i18n }
